import React, { Component } from "react";
import PropTypes from "prop-types";
import { Image, Shimmer } from "react-shimmer";
import errorImagePlaceholder from "../../assets/images/image-failed-to-load.png";
import { withTranslation } from "react-i18next";

class TLDRImage extends Component {
  render() {
    const { width, height, style = {}, alt, src, NativeImgProps, t } = this.props;
    return (
      <>
        <Image
          {...this.props}
          NativeImgProps={{ ...NativeImgProps, height, width, style }}
          src={src}
          alt={alt}
          width={width}
          height={height ? height : 152}
          color="gray.100"
          fallback={
            <Shimmer
              width={Number(width) || 152}
              height={Number(height) || 152}
              className="tldr-image-shimmer"
              duration={2000}
            />
          }
          errorFallback={(err) => {
            console.error(`Failed to load given URL ${src} due to ${err}`);
            return (
              <img
                src={errorImagePlaceholder}
                alt={t("errors.img_alt_error")}
                width={width}
                height={height}
              />
            );
          }}
          fadeIn={true}
        />
      </>
    );
  }
}

TLDRImage.propTypes = {
  src: PropTypes.string.isRequired,
};

TLDRImage.defaultProps = {
  alt: "",
  NativeImgProps: {},
};

export default withTranslation(["common"])(TLDRImage);
